import { element$ } from './element';
import { ElementOptions } from './element.options';

type ElementType = HTMLVideoElement;
export type VideoElementOptions = ElementOptions<ElementType> & {};
type Options = VideoElementOptions;

export function video$(): ElementType;
export function video$(classes: string): ElementType;
export function video$(classes: string, children: Element[]): ElementType;
export function video$(classes: string, options: Options): ElementType;
export function video$(
  classes: string,
  options: Options,
  children: Element[]
): ElementType;
export function video$(children: Element[]): ElementType;
export function video$(options: Options): ElementType;
export function video$(options: Options, children: Element[]): ElementType;
export function video$(
  arg1?: Options | Element[] | string,
  arg2?: Options | Element[],
  arg3?: Element[]
): ElementType {
  return element$('video', arg1, arg2, arg3);
}
